<div *ngIf="isPageReady" class="flex flex-col h-full w-full">
  <h2>Activation Errors for {{account!.name}}</h2>
  <div class="grow mt-2 pb-3">
    <prox-ag-grid [gridOptions]="gridOptions" [rowData]="activationService.activateErrors">
    </prox-ag-grid>
  </div>
  <div class="flex">
    <div class="mr-2">
      <p-button (click)="onOk()" size="small" label="Ok" icon="pi pi-check"></p-button>
    </div>
  </div>
</div>